import React, { Component } from 'react';
import Table, {
    TableHeader,
    TableHeaderRow,
    TableHeaderCell,
    TableBody,
    TableRow,
    TableCell
} from 'calcite-react/Table'

import Search from 'calcite-react/Search';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Button from '@mui/material/Button';
import fieldsDefinition from '../arcgisFilter/defaults/incidentFields.json';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import Grid from '@mui/material/Grid';

class IncidentEditDetails extends Component {

    constructor(props) {
        super(props)
        this.state =
        {
            searchIdentifer: null,
            searchValue: '',
            filterFields: [],
            showEditInfo: false,
            editInfoPackage: null,
            userFilterField: null
        };

        this.updateSearchValue = this.updateSearchValue.bind(this);
        this.onUserAction = this.onUserAction.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
    }

  componentWillReceiveProps(nextProps) 
    {
        if (nextProps.editInfoPackage !== this.props.editInfoPackage) 
            {
            if (nextProps.editInfoPackage === null || nextProps.editInfoPackage.EditEvents === null || nextProps.editInfoPackage.EditEvents.length === 0) 
                {
                this.setState({
                    filterFields: []
                });
                return;
            }
            let newFilterFields = [];
            for (var i = 0; i < nextProps.editInfoPackage.EditEntries.length; i++) 
                {
                if (newFilterFields.indexOf(nextProps.editInfoPackage.EditEntries[i].Attribute) === -1) 
                    {
                        newFilterFields.push(nextProps.editInfoPackage.EditEntries[i].Attribute);
                    }
                }
            this.setState({
                filterFields: newFilterFields
            });
        }
    }

    onUserAction(value) {
        this.setState({
            searchValue: value
        });
    }

    clearSearch() {
        this.setState({
            searchValue: '',
            userFilterField: null,
        })
    }

    updateSearchValue = (value) => {
        this.setState({
            searchValue: value,
            userFilterField: value
        });
    }

    getTitleForAttributeName = (attributeName) => {
        if (attributeName === "InformLastModifiedDate") {
            return "InFORM Last Modified Date"
        }

        if (attributeName === "IsCauseProhibited") {
            return "Is Cause Prohibited"
        }

        const fieldObject = fieldsDefinition[attributeName];
        return (fieldObject !== undefined && fieldObject !== null) ? fieldObject.alias : attributeName;
    }

    getDisplayValue = (attributeName, value) => {
        if (attributeName === "InformLastModifiedDate") {
            return (value) ? moment(new Date(parseInt(value))).format("MM/DD/YYYY h:mm A") : "NULL";
        }

        const fieldObject = fieldsDefinition[attributeName];
        if (fieldObject !== undefined && fieldObject !== null) {
            if (fieldObject.domain !== undefined && fieldObject.domain !== null) {
                try {
                    const codedValue = fieldObject.domain.codedValues.find(codedValue => codedValue.code.toString() === value.toString());
                    return (codedValue) ? codedValue.name : value;
                }

                catch (err) {
                    return (value === null || value === undefined) ? "NULL" : value;
                }
            }

            switch (fieldObject.type) {
                case "esriFieldTypeDate":
                    return (value && value !== "") ? moment(new Date(parseInt(value))).format("MM/DD/YYYY h:mm A") : "NULL";
                default:
                    return value;
            }
        } else {
            return value;
        }
    }

    getFilteredEditLog = (editLogEntries) => {
        return (
            <Table>
                <TableHeader>
                    <TableHeaderRow>
                        <TableHeaderCell><b>Attribute</b></TableHeaderCell>
                        <TableHeaderCell><b>Changed From</b></TableHeaderCell>
                        <TableHeaderCell><b>Changed To</b></TableHeaderCell>
                    </TableHeaderRow>
                </TableHeader>
                <TableBody>
                    {editLogEntries.map(editLog => {
                        return (
                            <TableRow>
                                <TableCell>{this.getTitleForAttributeName(editLog.Attribute)}</TableCell>
                                <TableCell>{(editLog.OldValue === null || editLog.OldValue === "") ? "NULL" : this.getDisplayValue(editLog.Attribute, editLog.OldValue)}</TableCell>
                                <TableCell>{this.getDisplayValue(editLog.Attribute, editLog.NewValue)}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        )

    }
    getUserEditContent = () => {
        const content = (this.props.editInfoPackage.EditEvents.length > 0) ?
            (
                this.props.editInfoPackage.EditEvents.map(editEvent => {
                    const editID = editEvent.EditID;
                    const filteredEditLog = this.props.editInfoPackage.EditEntries.filter(entry => entry.EditID === editID);
                    const hasUserFilter = (this.state.userFilterField !== null);
                    const editEventContainsFilter = (hasUserFilter) ? filteredEditLog.find(entry => entry.Attribute === this.state.userFilterField) : true;

                    //const shouldShould = (this.state.userFilterField === null || ((this.state.userFilterField !== null) &&  
                    return (editEventContainsFilter) ? (
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header">
                                <Typography>{editEvent.UserName} at {moment(editEvent.EditDate).format("MM/DD/YYYY h:mm A")}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {this.getFilteredEditLog(filteredEditLog)}
                            </AccordionDetails>
                        </Accordion>
                    ) : "";
                })
            ) : "";
        return content;
    }

    render() {
        if (!this.props.visible) {
            return null;
        }

        if (this.props.editInfoPackage.Error !== null && this.props.editInfoPackage.Error !== undefined && this.props.editInfoPackage.Error !== "") {
            return (
                <Paper>
                    <div className="row">
                        {this.props.editInfoPackage.Error}
                    </div>
                </Paper>
            );
        }

        const content =
            (
                <div style={{ minHeight: 700, width: 900 }}>
                    <Grid style={{ maxWidth: "700px", marginTop: "10px", marginLeft: "5px"}} container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={4}>
                            <b>Fire Occurence Record ID:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {this.props.editInfoPackage.FireOccurenceRecord.FireOccurenceRecordID}
                        </Grid>
                        <Grid item xs={4}>
                        <b>Incident Name:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {this.props.editInfoPackage.FireOccurenceRecord.IncidentName}
                        </Grid>
                        <Grid item xs={4}>
                        <b>Unique Fire Identifier:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {this.props.editInfoPackage.FireOccurenceRecord.UniqueFireIdentifier}
                        </Grid>
                        <Grid item xs={4}>
                        <b>InFORM Last Modified:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {moment(this.props.editInfoPackage.FireOccurenceRecord.InformLastModifiedDate).format('MM/DD/YYYY h:mm A')}
                        </Grid>
                        <Grid item xs={4}>
                        <b>IRWIN Last Modified:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {moment(this.props.editInfoPackage.FireOccurenceRecord.ModifiedOnDateTime).format('MM/DD/YYYY h:mm A')}
                        </Grid>
                        <Grid item xs={4}>
                            <b>Filter by attribute:</b>
                        </Grid>
                        <Grid item xs={8}>
                            <Search  style={{ marginTop: "-10px" }} fullWidth onRequestClear={this.clearSearch} items={this.state.filterFields} onChange={this.updateSearchValue} inputValue={this.state.searchValue} onUserAction={this.onUserAction} />
                        </Grid>
                    </Grid>
                    
                    {this.getUserEditContent()}

                </div>
            );

        return (
            <Paper>
                <div className="row">
                    {content}
                </div>
            </Paper>
        );
    }
}


export default IncidentEditDetails

